// Contract: awards-service application submit, POST /awards-service-api/cycles/{cycleId}/applications.
// The 4xx/5xx rule and the {"error": string} body live in @tempmee/awards (classifyAwardsFailure,
// AwardsErrorBody); this only unwraps the axios error the BID hooks reject with.
import { type AwardsFailure, classifyAwardsFailure } from '@tempmee/awards';
import { isAxiosError } from 'axios';

/**
 * How a failed Best in Dental application submit should be shown: `rejected`
 * shows the server's reason verbatim and keeps the form editable; `failed`
 * keeps the generic copy and its retry.
 */
export type TBidSubmitFailure = AwardsFailure;

export const classifyBidSubmitFailure = (error: unknown): TBidSubmitFailure =>
  isAxiosError(error)
    ? classifyAwardsFailure(error.response?.status, error.response?.data)
    : { kind: 'failed' };
